import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { AmountPipe } from '@bayclubs/utils';
import { Chart } from 'chart.js';
import moment from 'moment';
import { camps } from '../../../models/models.generated';
import { StatisticsApiService } from '../../../services/api/statistics-api.service';

import { TimeService } from '@bayclubs/utils';
import { debounceTime } from 'rxjs/operators';
import { DashboardFilterService } from '../dashboard-filter/dashboard-filter.service';

@Component({
    selector: 'app-daily-amount-chart',
    templateUrl: './daily-amount-chart.component.html',
    styleUrls: ['./daily-amount-chart.component.scss'],
    standalone: false
})
export class DailyAmountChartComponent implements OnInit, AfterViewInit {
    @Input()
    public filterForm: UntypedFormGroup;

    chart: any = [];

    public items: camps.RevenueDataItem[];

    private labels: Array<string> = [];
    private totalValues: Array<number> = [];

    constructor(
        private translate: TranslateService,
        private statisticsApi: StatisticsApiService,
        private dashboardFilterService: DashboardFilterService,
        private time: TimeService
    ) {}

    ngOnInit() {}

    ngAfterViewInit() {
        this.loadData();

        this.filterForm.valueChanges.pipe(debounceTime(100)).subscribe(() => {
            this.items = null;
            this.loadData();
        });
    }

    private loadData(): void {
        const filter = this.dashboardFilterService.getFilterResult(
            this.filterForm.controls['dateRange'].value
        );

        const campType = this.filterForm.controls['campType'].value;    

        this.statisticsApi
            .getRevenueOverview(<camps.ChartDataRequest>{
                dateFrom: this.time.toBcDate(filter.dateFrom),
                dateTo: this.time.toBcDate(filter.dateTo),
                timezone: this.time.defaultTimezone(),
                campTypes: campType ?  [this.filterForm.controls['campType'].value] : [],
            })
            .subscribe((response) => {
                this.items = response.value.data;

                this.prepareChartData();
                this.drawChart();
            });
    }

    public get isAnyValue(): boolean {
        if (!this.items) {
            return true;
        }

        return this.items.filter((x) => x.totalValue > 0).length > 0;
    }

    private prepareChartData(): void {
        this.labels = [];
        this.totalValues = [];

        for (var item of this.items) {
            this.labels.push(moment(item.date.value).format('MMM Do'));
            this.totalValues.push(item.totalValue);
        }
    }

    private drawChart(): void {
        let amountPipe = new AmountPipe();

        var config = {
            type: 'bar',
            data: {
                labels: this.labels,
                datasets: [
                    {
                        label: this.translate.instant(
                            'DailyAmountChart.TotalValue'
                        ),
                        fill: false,
                        backgroundColor: '#DC3545',
                        borderColor: '#DC3545',
                        data: this.totalValues,
                    },
                ],
            },
            options: {
                responsive: true,
                tooltips: {
                    mode: 'index',
                    intersect: false,
                },
                hover: {
                    mode: 'nearest',
                    intersect: true,
                },
                scales: {
                    xAxes: [
                        {
                            display: true,
                        },
                    ],
                    yAxes: [
                        {
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                callback: (value) => {
                                    return amountPipe.transform(
                                        value.toString(),
                                        2
                                    );
                                },
                            },
                        },
                    ],
                },
            },
        };
        if (this.chart && this.chart.destroy) {
            this.chart.destroy();
        }
        this.chart = new Chart('dailyAmount', config);
    }
}
